import React from 'react';
import styled from 'styled-components';

const Sup64 = styled.sup`
  font-size: 0.62em;
  letter-spacing: 0;
  vertical-align: super;
  line-height: 0;
`;

/** Renders “PixelDragon” with superscript 64. Use for all visible brand copy. */
export function PixelDragon64({ as: As = 'span', className, ...rest }) {
  return (
    <As className={className} {...rest}>
      PixelDragon<Sup64>64</Sup64>
    </As>
  );
}

/** Plain text for HTML title / meta tags (Unicode superscript digits). */
export const pixelDragon64Plain = 'PixelDragon\u2076\u2074';
